import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
  api_host: process.env.REACT_APP_MIXPANEL_DOMAIN,
  persistence: "localStorage",
  secure_cookie: true,
  ignore_dnt: true
});

export const trackEvent = (eventName, properties = {}) => {
  if (!eventName) {
    return;
  }
  mixpanel.track(eventName, properties);
};

export const trackMPPageView = (pageName) => {
  if (!pageName) {
    return;
  }

  mixpanel.track_pageview({ page: pageName });
  mixpanel.time_event(pageName);
};

export default mixpanel;
